export { makeLabelsDefs } from "./makeLabelsDefs";
